import { Component, Input } from '@angular/core';

@Component({
  selector: 'medrecord-ui-quote-column',
  templateUrl: './quote-column.component.html',
  styleUrls: ['./quote-column.component.scss']
})
export class QuoteColumnComponent {
  @Input() quote: string;
}